export default __webpack_public_path__ + "static/media/icon-menu-manager-index-active.51285b73.svg";